import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../api/ApiProvider.js';
import styles from './TodoBox.module.css';

/** Local-clock today as ISO YYYY-MM-DD (matches the rest of the live home). */
function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * Live To-Do box for the 4–8 Home. Shows the task lines the teacher planned
 * for today (read-only; planning happens in settings). Glass + 3D shadow via
 * the shared `.glass .glass--solid` utilities so it matches the room.
 */
export function TodoBox({ classroomId }: { classroomId: string }) {
  const api = useApi();
  const iso = todayIso();
  const todo = useQuery({
    queryKey: ['planner-todo', classroomId, iso],
    queryFn: () => api.planner.listTodo(classroomId, iso, iso),
    enabled: !!classroomId,
  });

  const lines = todo.data?.[0]?.lines ?? [];

  return (
    <section className={`glass glass--solid ${styles.box}`} data-testid="todo-box">
      <h2 className={styles.title}>To-Do</h2>
      {lines.length > 0 ? (
        <ol className={styles.list}>
          {lines.map((line, i) => (
            <li key={i} className={styles.item}>
              {line}
            </li>
          ))}
        </ol>
      ) : (
        <p className={styles.empty}>Nothing to do today.</p>
      )}
    </section>
  );
}
